<template>
  <div>
    <q-page-sticky
      style="z-index: 99999999"
      position="top-right"
      :offset="[0, 0]"
    >
      <q-btn
        v-if="!menu"
        flat
        @click="menu = true"
        fab
        icon="menu"
        :color="$route.meta.whiteMenu ? 'white' : 'black'"
      />
    </q-page-sticky>
    <q-page-sticky
      v-if="!$route.meta.backButtonDisabled"
      style="z-index: 99999999"
      position="bottom-left"
      :offset="[10, 10]"
    >
      <q-btn
        @click="handleBack()"
        fab
        icon="mdi-arrow-left"
        color="primary"
        padding="xs"
      />
    </q-page-sticky>
    <q-dialog v-model="menu" full-height full-width>
      <q-card class="column full-height" style="width: 300px">
        <div class="row full-height">
          <div class="col-12">
            <q-card-section
              class="row items-center q-pb-none text-center full-width"
            >
              <div
                class="text-h6 full-width"
                style="font-family: 'Outfit', cursive"
              >
                Main Menu
              </div>

              <q-btn
                icon="close"
                class="dialogCloseButton"
                flat
                round
                dense
                v-close-popup
              />
            </q-card-section>
          </div>
          <div class="col-12" style="height: calc(100% - 48px)">
            <q-scroll-area class="full-width" style="height: calc(100%)">
              <q-card-section class="col q-pt-none">
                <div class="row">
                  <div class="col-12 q-pt-md">
                    <q-btn
                      @click="
                        $router.push('/mobile-view/home');
                        menu = false;
                      "
                      size="md"
                      class="full-width"
                      outline
                    >
                      Home
                    </q-btn>
                  </div>
                  <div class="col-12 q-pt-md">
                    <q-btn
                      @click="
                        $router.push('/mobile-view/scheduled-mp-surveys');
                        menu = false;
                      "
                      size="md"
                      class="full-width"
                      outline
                    >
                      See Scheduled Surveys
                    </q-btn>
                  </div>
                  <div class="col-12 q-pt-md">
                    <q-btn
                      size="md"
                      @click="
                        $router.push('/mobile-view/mp-survey');
                        menu = false;
                      "
                      class="full-width"
                      outline
                    >
                      Start New Survey
                    </q-btn>
                  </div>
                  <!-- <div class="col-12 q-pt-md">
                    <q-btn
                      size="md"
                      @click="$router.push('/mobile-view/survey-mp-report')"
                      class="full-width"
                      outline
                    >
                      Test Survey Report (DEV)
                    </q-btn>
                  </div> -->
                  <div class="col-12 q-pt-md">
                    <q-btn
                      @click="
                        $router.push('/mobile-view/past-surveys');
                        menu = false;
                      "
                      size="md"
                      class="full-width"
                      outline
                    >
                      Past Surveys
                    </q-btn>
                  </div>
                  <!-- <div class="col-12 q-pt-md">
                    <q-btn
                      size="md"
                      @click="$router.push('/mobile-view/upload-data')"
                      class="full-width"
                      outline
                    >
                      Upload Data
                    </q-btn>
                  </div> -->
                  <div class="col-12 q-pt-md" v-if="!offlineMode">
                    <q-btn
                      @click="
                        $router.push('/mobile-view/user-profile');
                        menu = false;
                      "
                      size="md"
                      class="full-width"
                      outline
                    >
                      User Profile
                    </q-btn>
                  </div>
                  <div class="col-12 q-pt-md">
                    <q-btn
                      @click="
                        $router.push('/mobile-view/settings');
                        menu = false;
                      "
                      size="md"
                      class="full-width"
                      outline
                    >
                      Settings
                    </q-btn>
                  </div>
                  <div class="col-12 q-pt-md">
                    <q-btn
                      @click="
                        $router.push('/mobile-view/controller');
                        menu = false;
                      "
                      size="md"
                      class="full-width"
                      outline
                    >
                      Device Controller
                    </q-btn>
                  </div>
                  <!-- <div class="col-12 q-pt-md">
                    <q-btn
                      @click="
                        $router.push('/mobile-view/contact');
                        menu = false;
                      "
                      size="md"
                      class="full-width"
                      outline
                    >
                      Contact Tech Support
                    </q-btn>
                  </div> -->

                  <div class="col-12 q-pt-md" v-if="!currentUser">
                    <q-btn
                      size="md"
                      class="full-width"
                      color="primary"
                      @click="login()"
                      >Login</q-btn
                    >
                  </div>
                  <div
                    class="col-12 q-pt-md"
                    v-if="
                      !offlineMode && currentUser && currentUser != 'loading'
                    "
                  >
                    <q-btn
                      @click="logout()"
                      size="md"
                      class="full-width"
                      color="primary"
                    >
                      Log Off
                    </q-btn>
                  </div>
                  <!-- <div class="col-12 q-pt-md">
                    <q-btn
                      @click="$q.fullscreen.toggle()"
                      outline
                      size="md"
                      class="full-width"
                      color="black"
                    >
                      Toggle Full Screen
                    </q-btn>
                  </div> -->

                  <div v-if="!offlineMode" class="col-12 q-pt-md">
                    <q-btn
                      @click="$router.push('/surveys')"
                      size="md"
                      class="full-width"
                      outline
                      icon="mdi-monitor-dashboard"
                      label="Desktop Version"
                    >
                    </q-btn>
                  </div>
                </div>
              </q-card-section>

              <!-- <q-card-section
                align="center"
                class="bg-white text-teal q-py-none"
              >
                <q-img
                  src="/statics/TDRI_Logo_Light.png"
                  spinner-color="white"
                  style="height: 140px; max-width: 150px"
                />
              </q-card-section> -->
            </q-scroll-area>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["currentUser", "currentUserData", "offlineMode"]),
  },
  data: () => ({
    menu: false,
  }),
  components: {},
  beforeCreate() {},
  mounted() {},
  methods: {
    handleBack() {
      if (this.menu == false) {
        this.$router.go(-1);
      } else {
        this.menu = false;
      }
    },
    login() {
      this.$auth.loginWithPopup();
    },
    logout() {
      this.$store.dispatch("logout");
      setTimeout(() => {
        this.$auth.logout({
          returnTo: window.location.origin,
        });
      }, 10);
    },
  },
};
</script>
<style>
.dialogCloseButton {
  position: absolute !important;
  top: 10px;
  right: 10px;
}
</style>
